// extracted by mini-css-extract-plugin
export default {"content":"ofWxr4DU","description":"XlFYElV7","buttons":"gixyiSx7","button":"Uez1mztb"};